/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%] {\r\n    cursor: move;\r\n}\r\n\r\n.modal-lg[_ngcontent-%COMP%] {\r\n  max-width: 800px !important;\r\n}\r\n\r\n.modal-ultralg[_ngcontent-%COMP%] {\r\n  max-width: 70% !important;\r\n}"];
export { styles as styles };
